// ======================================================================
// File Name       : ContentLinkDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Col } from 'react-bootstrap';

const ContentLinkDetail = (props) => {
  const { contentSecernId, contentName, linkUrl } = props.contentLink;

  return (
    <div>
      <Col sm={12}>
        <Form className='form-horizontal'>
          <Form.Group className="form-info">
            <Col sm={4} className="form-label">
              コンテンツ識別ID
            </Col>
            <Col sm={7} className="padding-top-bottom-10">
              {contentSecernId}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={4} className="form-label">
              コンテンツ名
            </Col>
            <Col sm={7} className="padding-top-bottom-10">
              {contentName}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={4} className="form-label">
              リンク先URL
            </Col>
            <Col sm={7} className="padding-top-bottom-10">
              {linkUrl}
            </Col>
          </Form.Group>
        </Form>
      </Col>
    </div>
  );
};

export default ContentLinkDetail;
